import { useCallback } from 'react'
import type { UseQueryResult } from '@tanstack/react-query'

import type { HouseTreeNode } from '../types/catalog'
import type { InternalCompany } from '../types/internalCompany'
import { toHouseTree } from '../utils/companyMappers'
import { useCompaniesQuery } from './useCompaniesQuery'

export function useHousesQuery(companyId?: string): UseQueryResult<HouseTreeNode[]> {
  const select = useCallback(
    (data: InternalCompany[]) => toHouseTree(data, companyId ?? ''),
    [companyId],
  )
  return useCompaniesQuery({ select })
}
